module.exports = __webpack_public_path__ + "img/login-v2.619c2f75.svg";